import { Flex, View } from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import CallInProgress from "./CallInProgress/CallInProgress";
import "./style.css";
import { RootState } from "../../store/storeConfig";
import CallDialer from "./CallDialer/CallDialer";
import CallAcceptDialog from "../CallPage/CallAcceptDialog/CallAcceptDialog";
import InteractionDetails from "../common/InteractionDetails/InteractionDetails";
import { CALL, CONFERENCE } from "../../constants/constants";

const CallWebcase = () => {
  const call = useSelector((state: RootState) => state.call);
  const conference = useSelector((state: RootState) => (state as any).conference);

  return (
    <>
      {call.id || conference.id ? (
        <Flex width={"100%"} height={"100%"}>
          <View
            backgroundColor="static-white"
            width={"30%"}
            flex={1}
            height={"100%"}
          >
            <CallInProgress />
          </View>
          <Flex gap={"20px"} width={"70%"}>
            <View
              backgroundColor="static-white"
              gridArea="call detail"
              flex={2}
            >
              <InteractionDetails type={call?.id ? CALL : CONFERENCE} />
            </View>
          </Flex>
        </Flex>
      ) : (
        <Flex direction="row" height="100%">
          <CallDialer />
        </Flex>
      )}
      <CallAcceptDialog />
    </>
  );
};

export default CallWebcase;
